import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Tv, Lock } from 'lucide-react'

/**
 * What either broadcast view shows when there is nothing to show: the feature
 * is off, or this broadcast is not published to this customer. The API does not
 * distinguish "no such broadcast" from "not yours" and neither does this.
 */
const BroadcastUnavailable: React.FC<{ locked: boolean }> = ({ locked }) => {
  const navigate = useNavigate()
  return (
    <div className="p-6">
      <button onClick={() => navigate('/broadcasts?tab=broadcasts')}
              className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4">
        <ArrowLeft className="h-4 w-4 mr-1" />Back
      </button>
      <div className="bg-white rounded-lg border border-gray-200 py-14 text-center">
        {locked ? <Lock className="h-8 w-8 text-gray-300 mx-auto mb-2" />
                : <Tv className="h-8 w-8 text-gray-300 mx-auto mb-2" />}
        <p className="text-sm font-medium text-gray-600">
          {locked ? 'Broadcast analysis is not enabled' : 'Broadcast not available'}
        </p>
      </div>
    </div>
  )
}

export default BroadcastUnavailable
